import { MetricField } from "@/__generated__/graphql";
import { Grid } from "@mui/material";
import OptionSelector from "../../OptionSelector";
import { FormInputText } from "@components/form";
import { Control } from "react-hook-form";
import { FormValues } from "@features/createDeviceConfiguration/type/FormValues";

const sensorMetricConfig = {
  [MetricField.Level]: {
    label: 'nivel',
    keyName: 'Level'
  },
  [MetricField.Flow]: {
    label: 'flujo',
    keyName: 'Flow'
  },
  [MetricField.Velocity]: {
    label: 'velocidad',
    keyName: 'Velocity'
  },
};

interface SensorFormProps {
  sensorType: MetricField;
  control: Control<FormValues>;
  options: any[];
  selectedSensor: any;
}

const SensorForm = ({
  sensorType,
  control,
  options,
  selectedSensor,
}: SensorFormProps) => {
  const config = sensorMetricConfig[sensorType];

  if (!config) return null;

  const {label, keyName } = config;

  return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <OptionSelector
            options={options}
            label={`Sensor de ${label} *`}
            name={`sensor${keyName}Option`}
            control={control}
          />
        </Grid>
        {selectedSensor?.name === 'Integración' && (
          <>
            <Grid item xs={12}>
              <FormInputText
                name={`integrationDetail${keyName}`}
                control={control}
                label="Detalle de Integración"
              />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <FormInputText
            name={`serialNumber${keyName}`}
            control={control}
            label={`Número de serie del sensor de ${label} *`}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInputText
            name={`modbusId${keyName}`}
            control={control}
            label={`Modbus ID del sensor de ${label}`}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInputText
            name={`batchNumber${keyName}Sensor`}
            control={control}
            label={`Número de lote del sensor de ${label} *`}
          />
        </Grid>
      </Grid>
  );
};

export default SensorForm;